<section [title]="title()">
  <ideal-cart-item-result-list [ids]="ids()" />
</section>
